import { useState } from "react"
import MTable from "../../../../components/mtable"
import Input, { required, submitForm, useInput } from "../../../../components/input"
import { api, FRONT } from "../../../../env"

export default function CompanyUserInvites({companyId}) {
        
    const [isCreate, setIsCreate] = useState(false);

    const usersMapper = {
        columns: [
            {
                label: "Email",
                value: (item) => item.email,
            },
            {
                label: "",
                width: "300px",
                actions: [
                    {
                        label: "Copy Sign Up Code",
                        style: (_) => "outline",
                        onClick: (item) => {
                            navigator.clipboard.writeText(`${FRONT}signup/${item.signUpCode}`);
                        },
                    },
                    {
                        label: "Resend Email",
                        style: (_) => "solid-accent",
                        onClick: (item) => {
                            api.post(`invitations/${item.id}/resend`)
                                .then((res) => {
                                    alert("Invitation email resent successfully");
                                })
                                .catch((err) => {});
                            //TODO (Strale) Replace with custom toast
                        },
                    },
                ],
            },
        ],
    };

    return (
        <>
            <div className="flex space-between center gap-xs v-spacer-m">
                <p className="section-title">Manager Invites</p>
                {!isCreate && (
                    <button className="text" onClick={() => setIsCreate(true)}>
                        Create
                    </button>
                )}
            </div>
            {!isCreate && <MTable path={`companies/${companyId}/invites`} mapper={usersMapper} />}
            {isCreate && <CreateCompanyUser companyId={companyId} onClose={() => setIsCreate(false)} />}
        </>
    );
}

function CreateCompanyUser({ companyId, onClose }) {
    const createForm = {
        email: useInput("Email", "email", "email", [required]),
    };

    const handleCreate = () => {
        const userInfo = submitForm(createForm);
        if (!userInfo) return;

        api
            .post(`companies/${companyId}/invites`, userInfo)
            .then((res) => {
                console.log(res.data);
                onClose();
            })
            .catch((err) => {
                console.log(err);
                onClose();
            });
    };

    return (
        <div className="card flex columns gap-xs showing">
            <Input state={createForm.email} />
            <div className="flex gap-xs justify-end">
                <button className="outline" onClick={onClose}>
                    Cancel
                </button>
                <button className="solid-accent" onClick={handleCreate}>
                    Create
                </button>
            </div>
        </div>
    );
}